<template>
  <div>

    <loading-indicator
      v-if="isLoading"
      :useDelay="false"
    />

    <div v-if="data" class="container">

      <blockquote class="blockquote text-center">
        <b-button @click="saveState" variant="primary">Save changed state</b-button>
      </blockquote>

      <vue-json-editor v-model="data"/>

    </div>
 </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import LoadingIndicator from './LoadingIndicator.vue';
import vueJsonEditor from 'vue-json-editor';
import pako from 'pako';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'PlayerStateEditor',

  components: {
    LoadingIndicator,
    vueJsonEditor,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,

      data: null,
    }
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },
  },

  created() {
    this.loadState();
  },

  methods: {
    loadState() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const url = '/player/' + this.playerId + '/data_game';
      HTTP.get(url)
      .then(response => {
        this.data = response.data.data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    saveState() {
      const dataStr = JSON.stringify(this.data);
      const dataCompressed = pako.deflate(dataStr);

      const url = '/player/' + this.playerId + '/data_game';

      HTTP.post(url, dataCompressed)
      .then(() => {
        notifier.showSuccess('State changed.');
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },
  },
};
</script>
